import React, { useState, useEffect } from "react";
import axios from "axios";
import { Bell, Check } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StockAlertForm = ({ productId, productName }) => {
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [waiting, setWaiting] = useState(0);
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.email) setEmail(user.email);
    axios.get(`${API}/stock-alerts/count/${productId}`)
      .then(({ data }) => setWaiting(data.waiting || 0))
      .catch(() => { /* ignore */ });
  }, [productId, user]);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/stock-alerts`, {
        product_id: productId,
        email,
      });
      setSubscribed(true);
      if (!data.already_subscribed) setWaiting((n) => n + 1);
      toast.success("Nous vous préviendrons dès son retour");
    } catch {
      toast.error("Erreur — réessayez plus tard");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="stock-alert-block" className="border border-[color:var(--gold)]/30 bg-[color:var(--gold)]/[0.03] p-6 mb-12">
      <div className="flex items-start gap-3 mb-4">
        <Bell size={16} className="text-[color:var(--gold)] mt-0.5" strokeWidth={1.5} />
        <div>
          <p className="text-white text-sm font-serif">{productName} — momentanément indisponible</p>
          <p className="text-white/50 text-xs mt-1">
            {waiting > 0
              ? `${waiting} personne${waiting > 1 ? "s attendent" : " attend"} le retour de ce parfum.`
              : "Soyez averti dès sa remise en vente."}
          </p>
        </div>
      </div>
      {subscribed ? (
        <p className="flex items-center gap-2 text-[color:var(--gold)] text-sm">
          <Check size={16} strokeWidth={1.5} /> Vous serez prévenu par email.
        </p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
          <input
            data-testid="stock-alert-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Votre email"
            className="input-line flex-1"
          />
          <button
            data-testid="stock-alert-submit"
            type="submit"
            disabled={loading}
            className="btn-outline"
          >
            {loading ? "..." : "Me prévenir"}
          </button>
        </form>
      )}
    </div>
  );
};

export default StockAlertForm;
